import { getUniverseAggregateLabel, UniverseMetric } from '@weenat/client/dist/core/universes'
import { Aggregations } from '@weenat/client/dist/enums'
import { useIntl } from '@weenat/wintl'
import { RestrictionReason } from 'app/src/hooks/useIsAppAccessRestricted'
import { memo } from 'react'
import useUniverseBackgroundMapContext from '../universes/useUniverseBackgroundMapContext'
import { PlotListItemsVariants } from './PlotListItemMetricSummary'
import PlotListItemValue, { PlotSummaryValue } from './PlotListItemValue'
import PlotListItemValuesContainer from './PlotListItemValuesContainer'

interface LatestValueOnlyPlotListItemValuesProps {
  now: PlotSummaryValue
  metric: UniverseMetric
  /** All values are restricted in the same way -- No need to pass isVirtualDevice  */
  isRestricted: boolean
  reason: RestrictionReason
  variant: PlotListItemsVariants
}

/**
 * PlotListItem values for metrics that only display real-time (no min/max), e.g. soil temperature
 * Doesn't come from a virtual device
 */
const LatestValueOnlyPlotListItemValues: FC<LatestValueOnlyPlotListItemValuesProps> = ({
  now,
  metric,
  isRestricted,
  reason,
  variant
}) => {
  const { t } = useIntl()
  const { aggregate } = useUniverseBackgroundMapContext()

  return (
    <PlotListItemValuesContainer $isRestricted={isRestricted}>
      <PlotListItemValue
        isMainValue
        value={now}
        name={t(`map.universes.aggregate.${getUniverseAggregateLabel('real-time')}`)}
        metric={metric}
        selected={aggregate === Aggregations.latest}
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
    </PlotListItemValuesContainer>
  )
}

export default memo(LatestValueOnlyPlotListItemValues)
